/* eslint-disable no-undef */

/**
 * API / socket URLs come from build-time env (Create React App).
 *
 * Priority:
 * 1) Azure DevOps Library variable group → Docker build-args (CI/UAT)
 * 2) .env.uat / .env.production via env-cmd --no-override (local)
 * 3) localhost fallback
 */
const getEnvVars = () => {
  const apiUrl = process.env.REACT_APP_API_URL?.trim();
  const socketUrl = process.env.REACT_APP_SOCKET_URL?.trim();

  if (apiUrl && socketUrl) {
    return { apiUrl, socketUrl };
  }

  // Local / fallback when build-args are not set
  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return {
        apiUrl: 'http://localhost:5000/api',
        socketUrl: 'http://localhost:5000'
      };
    }
    // Same-origin proxy setups (custom domain routing /api → backend)
    return {
      apiUrl: `${origin}/api`,
      socketUrl: origin
    };
  }

  return {
    apiUrl: 'http://localhost:5000/api',
    socketUrl: 'http://localhost:5000'
  };
};

export default getEnvVars;
